/**
 * Reward Status Chip Component
 * Displays reward status with appropriate icon and color
 */

import { Chip } from '@mui/material'
import {
  CheckCircle,
  Schedule,
  Redeem,
  Cancel,
  Help,
} from '@mui/icons-material'
import { RewardInstanceStatus, getInstanceStatusName } from '@api/types/rewards'
import { getStatusColor } from '../utils/rewardHelpers'

interface RewardStatusChipProps {
  status: RewardInstanceStatus
  size?: 'small' | 'medium'
}

function getStatusIcon(status: RewardInstanceStatus) {
  switch (status) {
    case RewardInstanceStatus.Active:
      return <CheckCircle fontSize="small" />
    case RewardInstanceStatus.Expired:
      return <Schedule fontSize="small" />
    case RewardInstanceStatus.FullyRedeemed:
      return <Redeem fontSize="small" />
    case RewardInstanceStatus.Revoked:
      return <Cancel fontSize="small" />
    default:
      return <Help fontSize="small" />
  }
}

export function RewardStatusChip({ status, size = 'small' }: RewardStatusChipProps) {
  return (
    <Chip
      icon={getStatusIcon(status)}
      label={getInstanceStatusName(status)}
      color={getStatusColor(status)}
      size={size}
    />
  )
}
